export default "__VITE_ASSET__CzRITkYQ__"